<!--
 * @Author: 张天昊
 * @Date: 2024-05-21 16:47:53
 * @LastEditTime: 2024-06-26 16:19:11
 * @LastEditors: 张天昊
 * @Description: 旅行社面板
 * @FilePath: /Mobile/src/pages/itineraryUniversal/components/TravelAgencyPanel.vue
-->
<script>
import { defineComponent, computed } from 'vue';
import BlockWithTitle from './BlockWithTitle.vue';
import TravelAgencyCard from './TravelAgencyCard.vue';
import DataEmpty from './DataEmpty.vue';
import store from '@/store';
import { useAuxiliaryInfoCardScroll } from '../composables/useAuxiliaryInfoCardScroll';
import { usePanelMinHeight } from '../composables/usePanelMinHeight';
import { AuxiliaryInfoTypes, TravelAgencyTypes } from '../constants';

export default defineComponent({
  name: 'TravelAgencyPanel',
  components: {
    BlockWithTitle,
    TravelAgencyCard,
    DataEmpty
  },
  setup(_, { expose }) {
    const detailInfo = computed(
      () => store.state.itineraryUniversal.detailInfo.value
    );
    const group = computed(() => {
      if (
        !detailInfo.value &&
        !detailInfo.value.itineraryTravelMessage.length
      ) {
        return null;
      }
      return {
        组团社: detailInfo.value.itineraryTravelMessage.filter(
          (item) => item.type === TravelAgencyTypes.组团社
        ),
        委托社: detailInfo.value.itineraryTravelMessage.filter(
          (item) => item.type === TravelAgencyTypes.省外组团社
        ),
        地接社: detailInfo.value.itineraryTravelMessage.filter(
          (item) => item.type === TravelAgencyTypes.地接社
        )
      };
    });
    const selfTeamNo = computed(() =>
      detailInfo.value ? detailInfo.value.itineraryInfoMessage.selfTeamNo : ''
    );

    const { cards, anchorTo } = useAuxiliaryInfoCardScroll(
      AuxiliaryInfoTypes.旅行社
    );
    const { panelMinHeight } = usePanelMinHeight();

    expose({
      anchorTo
    });
    return {
      selfTeamNo,
      group,
      cards,
      panelMinHeight
    };
  }
});
</script>

<template>
  <div class="px-12 pt-16" :style="{ minHeight: panelMinHeight }">
    <template v-if="group">
      <template v-for="[title, datas] in Object.entries(group)">
        <BlockWithTitle
          v-if="datas.length"
          :key="title"
          :title="title"
          class="[&:not(:first-child)]:mt-20"
        >
          <TravelAgencyCard
            v-for="data in datas"
            :key="data.travelId"
            :data="{ ...data, selfTeamNo }"
            class="[&:not(:first-child)]:mt-12"
            ref="cards"
          />
        </BlockWithTitle>
      </template>
    </template>
    <DataEmpty v-else />
  </div>
</template>
